var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "rule__footer"
  }, [_c('p', [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_333069'
  })))]), _c('p', [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_342809'
  })))]), _c('p', [_vm._v(_vm._s(_vm.$k18n({
    id: 'k_342808'
  })))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }